import {useEffect,useState} from "react";
import axios from "axios";

import API_URL from "../config/config";
import AdminSidebar from "../components/AdminSidebar";

import "../css/admin.css";
import { useNavigate } from "react-router-dom";

function AdminOrders(){


const [orders,setOrders]=useState([]);

const [selectedOrder, setSelectedOrder] = useState(null);

useEffect(()=>{

loadOrders();

},[]);



const loadOrders=()=>{


axios.get(
`${API_URL}/admin/orders`
)

.then(res=>{

setOrders(res.data);

});


};


const navigate = useNavigate();

useEffect(() => {

    const role = localStorage.getItem("role");

    if (role !== "admin") {

        alert("Access Denied");

        navigate("/");

    }

}, [navigate]);


const updateStatus=(id,status)=>{


axios.put(

`${API_URL}/admin/orders/${id}`,

{
order_status:status
}

)

.then(()=>{

loadOrders();

});


};





return(

<div className="admin-layout">


<AdminSidebar/>


<div className="admin-content">


<h1>
Orders
</h1>



<table className="admin-table">


<thead>

<tr>

<th>ID</th>
<th>Customer</th>
<th>Email</th>
<th>Total</th>
<th>Payment</th>
<th>Status</th>
<th>Action</th>

</tr>


</thead>



<tbody>


{

orders.map(order=>(


<tr key={order.id}>


<td>
#{order.id}
</td>


<td>
{order.first_name} {order.last_name}
</td>


<td>
{order.email}
</td>


<td>
₹{order.total}
</td>


<td>
{order.payment_status}
</td>



<td>

<select

value={order.order_status}

onChange={(e)=>
updateStatus(
order.id,
e.target.value
)
}

>


<option>
Pending
</option>


<option>
Processing
</option>


<option>
Shipped
</option>


<option>
Delivered
</option>


<option>
Cancelled
</option>


</select>


</td>



<td>

<button
    className="edit-btn"
    onClick={() => setSelectedOrder(order)}
>
    View
</button>

</td>



</tr>


))

}


</tbody>



</table>

{selectedOrder && (
    <div className="order-modal">

        <div className="order-modal-content">

            <button
                className="close-btn"
                onClick={() => setSelectedOrder(null)}
            >
                ✕
            </button>

            <h2>Order Details</h2>

            <p>
                <strong>Order ID:</strong> #{selectedOrder.id}
            </p>

            <p>
                <strong>Customer:</strong>{" "}
                {selectedOrder.first_name} {selectedOrder.last_name}
            </p>

            <p>
                <strong>Email:</strong> {selectedOrder.email}
            </p>

            <p>
                <strong>Phone:</strong> {selectedOrder.phone || "N/A"}
            </p>

            <p>
                <strong>Address:</strong>{" "}
                {selectedOrder.address || "N/A"}
            </p>

            <p>
                <strong>City:</strong> {selectedOrder.city || "N/A"}
            </p>

            <p>
                <strong>State:</strong> {selectedOrder.state || "N/A"}
            </p>

            <p>
                <strong>ZIP Code:</strong>{" "}
                {selectedOrder.zip_code || "N/A"}
            </p>

            <hr />

            <p>
                <strong>Total:</strong> ₹{selectedOrder.total}
            </p>

            <p>
                <strong>Payment Status:</strong>{" "}
                {selectedOrder.payment_status}
            </p>

            <p>
                <strong>Order Status:</strong>{" "}
                {selectedOrder.order_status}
            </p>

            <button
                className="close-order-btn"
                onClick={() => setSelectedOrder(null)}
            >
                Close
            </button>

        </div>

    </div>
)}

</div>


</div>


);


}


export default AdminOrders;